import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from "../../../core/auth/auth.service";
import { Router } from "@angular/router";
import { AsyncPipe } from '@angular/common';
import { Observable, from, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { UserService } from "../../../core/services/user.service";
import { User } from "../../../models/User/user.interface";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, AsyncPipe],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  user$: Observable<User | null>;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initializeUserData();
  }

  initializeUserData(): void {
    this.user$ = this.authService.isAuthenticated$.pipe(
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          return of(null);
        }
        return from(this.authService.getUserEmail()).pipe(
          switchMap((email: string) => this.userService.getUserByEmail(email)),
          catchError((error) => {
            console.error('Error loading user data:', error);
            return of(null);
          })
        );
      })
    );
  }

  logout(): void {
    this.authService.signOut().then(() => {
      this.router.navigate(['/account/login']);
    });
  }

}
